<!-- <body id="body"> -->

<aside>

	<div class="full-height-container">




		<p-tree [value]="treeNodes" selectionMode="single" [(selection)]="selectedNode"
			(onNodeSelect)="onNodeSelect($event)"
			[loading]="loading"
			[lazy]="true"
			class="full-height-tree">
		</p-tree>

	</div>


	<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">

		<div class="panel panel-heading">


		</div>




		<!-- <div class="panel">
				<div class="panel-heading" role="tab" id="headingOne">
					<h4 class="panel-title">
						<a class="collapsed" id="dashboardLink" [routerLink]="['/boards']" (click)="toggleSubMenu($event)">
							Dashboard
							<i class="la la-bar-chart"></i>
						</a>
					</h4>
				</div>
			</div>
			<div class="panel" id="index">
				<div class="panel-heading" role="tab" id="headingOne">
					<h4 class="panel-title">
						<a class="collapsed" id="oppLink" [routerLink]="['/opportunities']" (click)="toggleSubMenu($event)">
							Opportunities
							<i class="la la-suitcase"></i>
						</a>
						<div class="panel" id="wonOpportunities" [class]="opportunitiesClass">
							<a class="collapsed" [routerLink]="['/opportunities', 'Won']" (click)="toggleSubMenu($event)">
								Won Opportunities
								<i class="la la-suitcase-rolling"></i>
							</a>
						</div>
						<div class="panel" id="wonOpportunities" [class]="opportunitiesClass">
							<a class="collapsed" [routerLink]="['/opportunities', 'Closed']" (click)="toggleSubMenu($event)">
								Closed Opportunities
								<i class="la la-suitcase-rolling"></i>
							</a>
						</div>
					</h4>
				</div>
			</div>

			<div class="panel" id="leads"
				sec:authorize="hasAnyAuthority('Admin','Sales','VP', 'Sales Manager')||hasAnyAuthority('Director', 'VP', 'Sales Manager', 'Brand Lead')">
				<div class="panel-heading" role="tab" id="headingOne">
					<h4 class="panel-title">
						<a class="collapsed" id="leadsLink" [routerLink]="['/leads']" (click)="toggleSubMenu($event)">
							Add Opportunity
							<i class="la la-plus-circle"></i>
						</a>
					</h4>
				</div>
			</div> -->


		<!-- comment -->
		<!-- <div class="panel" id="data" sec:authorize="hasAnyAuthority('Admin','Director', 'Sales Manager')">
				<div class="panel-heading" role="tab" id="headingOne">
					<h4 class="panel-title">
						<a class="collapsed" href="/data">
							Data
							<i class="la la-database"></i>
						</a>
					</h4>
				</div>
			</div> -->


		<!-- <div class="panel" id="settings"
			*ngIf="userManagement || customerManagement || lookupManagement">
				<div class="panel-heading" role="tab" id="headingOne">
					<h4 class="panel-title">
							 <a class="collapsed" id="settingsLink" (click)="toggleSubMenu($event)">
								<i class="la la-gear"></i>
								Settings
							 </a>
							<div class="panel" id="userManagementGroup" [class]="settingClass"
							*ngIf="userManagement" #ele>
								<a class="collapsed" [routerLink]="['/usermgmt']" (click)="toggleSubMenu($event)">
									User Management
									<i class="la la-users"></i>
								</a>
							</div>
							<div class="panel" id="userManagementGroup" [class]="settingClass"
							*ngIf="customerManagement" #ele>
								<a class="collapsed" [routerLink]="['/customermgmt']" (click)="toggleSubMenu($event)">
									Customer Management
									<i class="la la-user-tie"></i>
								</a>
							</div>
							<div class="panel" id="userManagementGroup" [class]="settingClass"
							*ngIf="lookupManagement" #ele>
								<a class="collapsed" [routerLink]="['/lookupmgmt']" (click)="toggleSubMenu($event)">
									Lookup Management
									<i class="la la-gear"></i>
								</a>
							</div>
					</h4>
				</div>
			</div> -->
	</div>

</aside>
<!-- </body> -->
